export default __webpack_public_path__ + "media/zurb/img/legacy/strike/instructions-6-2494c5814ec44e62d487977fdd697045.jpg";